(function ($) {
  "use strict";

  // Ouvre un lien externe ou un PDF dans un nouvel onglet.
  Drupal.behaviors.externalHyperlinks = {
    attach: function (context, settings) {
      $(document.links, context)
        .filter(function() { return this.hostname !== window.location.hostname || this.href.match(/\.pdf$/i); })
        .attr('target', '_blank')
        .attr('rel', 'noreferer,noopener');
    }
  };

}(jQuery));
